<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="currentBalance > 0; else noBonusCredit">
    <ng-container *ngIf="partners.length > 0; else noPartners">
      <form class="transfer-cash-container" *ngIf="transferCreaditForm" [formGroup]="transferCreaditForm">
        <div class="bonus-transfer-memberid-field mb-0">
          <div class="form-floating">
            <select class="form-select font-size-14" id="selectPartner" formControlName="memberId">
              <option class="font-size-14" *ngFor="let partner of partners" [value]="partner.MemberId">
                {{ partner.FullName }} ({{ partner.Email }})
              </option>
            </select>
            <label for="selectPartner" class="fw-normal text-info">{{ 'transfer.select.partner.label' | translate }}</label>
          </div>
          <div *ngIf="submitted && f.memberId.value.errors" class="alert alert-danger font-size-12">
            <div *ngIf="f.memberId.value.errors.required">{{ 'ecash.email.required' | translate }}</div>
            <div *ngIf="f.memberId.value.errors.pattern">{{ 'ecash.email.incorrect' | translate }}</div>
          </div>
        </div>
        <div class="bonus-transfer-amount-field mb-0">
          <div class="input-group position-relative">
            <span class="input-group-text dollar-icon">$</span>
            <div class="form-floating">
              <input class="form-control dollar-input rounded" id="transferAmount" formControlName="amount" />
              <label for="transferAmount" class="fw-normal text-info">Amount</label>
            </div>
          </div>
          <div *ngIf="submitted && f.amount.errors" class="alert alert-danger font-size-12">
            <div *ngIf="f.amount.errors.required">{{ 'ecash.amount.required' | translate }}</div>
            <div *ngIf="f.amount.errors.pattern">{{ 'ecash.amount.number.only' | translate }}</div>
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-primary fw-bold font-size-14 rounded send-btn"
          confirmModal
          [confirmContent]="confirmBonusTranser"
          (confirm)="transferBonusCredit(f.amount.value)"
          [disabled]="
            currentBalance <= 0 || f.amount.value > currentBalance || f.amount.value < minTransfer || !transferCreaditForm.valid
          "
        >
          {{ 'ecash.transfer.button' | translate }}
        </button>
      </form>
    </ng-container>
    <ng-template #noPartners>
      <div class="border w-100 rounded py-3 mt-4 bg-white">
        <p class="font-size-14 text-center my-0">{{ 'bonus.transfer.no.partner' | translate }}</p>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #confirmBonusTranser>
    <div class="transfer-modal-header d-flex align-items-center justify-content-between border-bottom px-3 pb-3">
      <div class="fw-bold mb-0 font-size-14 text-capitalize">{{ 'bonus.transfer.confirm.title' | translate }}</div>
      <span class="material-icons fw-bold font-size-18 me-2 text-info cursor-pointer" aria-hidden="true" (click)="dismissModal()"
        >close</span
      >
    </div>
    <p class="p-3 pb-4 mb-0 font-size-14">
      {{ 'bonus.transfer.confirm.description' | translate }}
      <span class="text-success fw-bold">{{ f.amount.value | FortressCurrencyPipe }} </span>
      {{ 'bonus.transfer.confirm.description.to' | translate }}
      <span class="text-tertiary fw-bold">{{ targetMemberEmail }}</span>
      <span class="fw-bold">{{ 'bonus.transfer.confirm.description.qmark' | translate }} </span>
    </p>
    <p class="px-3 text-lg-start pb-3transfer-modal-header-confirm-policy">
      {{ 'bonus.transfer.confirm.description.policy' | translate }}
    </p>
  </ng-template>

  <ng-template #noBonusCredit>
    <div class="border w-100 rounded py-3 mt-4 bg-white">
      <p class="font-size-14 text-center my-0">{{ 'bonus.transfer.no.credit' | translate }}</p>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="isLoading">
  <fgbcl-loading></fgbcl-loading>
</ng-container>

<!--modal content after transfer has been attempted-->
<ng-template #successTransfer let-modal>
  <div class="text-center transfer-status-modal p-3">
    <div class="d-flex align-items-center justify-content-center border-bottom">
      <div class="fw-bold mb-0 font-size-14 text-success text-capitalize pt-2 pb-3">
        {{ 'bonus.transfer.success.title' | translate }}
      </div>
    </div>
    <p class="text-center mt-4 mb-3">
      <span class="fw-bold">{{ targetMemberEmail }}</span>
      {{ 'bonus.transfer.success.description' | translate }}
      <span class="fw-bold">{{ f.amount.value | FortressCurrencyPipe }} </span>
    </p>
    <button class="back-transfer-btn btn btn-primary fw-bold mt-3" (click)="modal.dismiss('close')">
      {{ 'bonus.transfer.success.btn' | translate }}
    </button>
  </div>
</ng-template>
<ng-template #failedTransfer let-modal>
  <div class="text-center transfer-status-modal p-3">
    <div class="d-flex align-items-center justify-content-center border-bottom pb-2">
      <div class="fw-bold mb-0 font-size-14 text-danger text-capitalize">{{ 'bonus.transfer.unsuccess.title' | translate }}</div>
    </div>
    <p class="fw-bold text-center my-2">
      <span class="text-danger">{{ targetMemberEmail }}</span>
      {{ 'bonus.transfer.unsuccess.description' | translate }}
      <span class="text-success">{{ f.amount.value | FortressCurrencyPipe }} </span>
    </p>
    <button class="btn btn-danger w-100 fw-bold mt-3" (click)="modal.dismiss('close')">
      {{ 'bonus.transfer.unsuccess.btn' | translate }}
    </button>
  </div>
</ng-template>
